<div class="card bc-card " style="height: 100%; margin-left: 12px;">
    <div class="row participants-row">
        <div class="col">
            <tabset class="m-1">
                <tab customClass="groupClassDetails">
                    <ng-template tabHeading>
                        <strong class="text-dimmed" translate>GroupClassDetails.ParticipantsHeader</strong>
                    </ng-template>
                    <div app-group-classes-details-attendens [model]="model"
                        (attendensLoaded)="onAttendanceLoaded($event)">
                    </div>
                </tab>
                <tab customClass="groupClassDetails" *ngIf="showWaitList">
                    <ng-template tabHeading>
                        <strong class="text-dimmed" translate>GroupClassDetails.WaitListHeader</strong>
                    </ng-template>
                    <app-group-classes-details-wait-list [model]="model"></app-group-classes-details-wait-list>
                </tab>
            </tabset>
        </div>
    </div>
    <div class="row add-participants-row mx-5 mb-3">
        <div class="col ">
            <app-group-classes-add-participants [model]="model" [attendance]="attendance"></app-group-classes-add-participants>
        </div>
    </div>
</div>
